import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=2e046b9e&scoped=true&"
import script from "./newsDetails.vue?vue&type=script&lang=ts&"
export * from "./newsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./newsDetails.vue?vue&type=style&index=0&id=2e046b9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e046b9e",
  null
  
)

export default component.exports